import { StatCircle } from '@/components/patterns/StatCircle';
import { StatCircleReveal } from '@/components/patterns/StatCircleReveal';
import { TrendArrowIcon } from '@/components/primitives/icons/TrendArrowIcon';
import { redListIndexMotion } from '@/config/red-list-index';
import {
  RED_LIST_INDEX_DETERIORATED_COLOR,
  RED_LIST_INDEX_IMPROVED_COLOR,
} from '@/constants/stateCharts';

import styles from './RedListIndexSideStats.module.css';

import type { RedListIndexStats } from '@/content/data/charts/red-list-index';

type RedListIndexSideStatsProps = {
  stats: RedListIndexStats;
  improvedCaption: string;
  deterioratedCaption: string;
};

/**
 * Flanking Graph Stat pods — improved (green ↑) / deteriorated (red ↓).
 * Entrance: spring-badge via {@link StatCircleReveal}, staggered like chord
 * callout discs. Arrows: Figma `Vector 138` via {@link TrendArrowIcon}.
 */
export function RedListIndexSideStats({
  stats,
  improvedCaption,
  deterioratedCaption,
}: RedListIndexSideStatsProps) {
  return (
    <div className={styles.root}>
      <StatCircleReveal>
        <StatCircle variant="pod" className={styles.pod}>
          <StatCircle.Value style={{ color: RED_LIST_INDEX_IMPROVED_COLOR }}>
            <span>{stats.improvedCount}</span>
            <span className={styles.arrow} aria-hidden>
              <TrendArrowIcon direction="up" />
            </span>
          </StatCircle.Value>
          <StatCircle.Caption>{improvedCaption}</StatCircle.Caption>
        </StatCircle>
      </StatCircleReveal>

      <StatCircleReveal delay={redListIndexMotion.sideStatStaggerSeconds}>
        <StatCircle variant="pod" className={styles.pod}>
          <StatCircle.Value
            style={{ color: RED_LIST_INDEX_DETERIORATED_COLOR }}
          >
            <span>{stats.deterioratedCount}</span>
            <span className={styles.arrow} aria-hidden>
              <TrendArrowIcon direction="down" />
            </span>
          </StatCircle.Value>
          <StatCircle.Caption>{deterioratedCaption}</StatCircle.Caption>
        </StatCircle>
      </StatCircleReveal>
    </div>
  );
}
